<script>
import {slots_tool} from "./slots_tool";
export default {
  name: "Game5016",
  props:{
    mapList: [],
    wins: [],
    lang: '',
    Phone:false,
  },
  data() {
    return {

    };
  },
  created()
  {
      // console.log(this.mapList);
      // console.log(this.wins);
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  watch: {

  },
  methods: {
      handleResize(){
        console.log("handleResize")

      },
      drawLines() {
        this.$nextTick(() => {

          setTimeout(this.drawWinLines, 10);

        })
      },
      drawWinLines()
      {
            slots_tool.clearLines();
            let wins = this.wins;
            if (wins && wins.length > 0) {
              let len = wins.length;
              for (let index = 0; index < len; index++) {
                let winInfos = wins[index];
                if (winInfos)
                {
                  for (let j = 0; j < winInfos.length; j++) {
                    let winIndex = winInfos[j].win_index;
                    if (winIndex)
                    {
                       let wLen = winIndex.length;
                        for (let m = 0; m < wLen-1; m++)
                        {
                            let fromIndex = index+"_" + winIndex[m];
                            let toIndex = index+"_" + winIndex[m+1];
                            slots_tool.drawLines("m_"+ fromIndex, "m_" + toIndex, j)
                        }
                    }
                  }
                }
              }
            }
            this.timer = false;
        }
    }
}
</script>

<template>
  <div>
      <div class="top">
        <div class="gametitle">
          {{ $t(`lang.str_detail`) }}
        </div>
      </div>
      <div class="gameSlotsImgArea" v-for="(mapTmp, key) in mapList" :key="key">
        <div class="box" v-for="(item, index) in mapTmp" :key="index" :id="'m_' + key + '_' + index">
          <div class="icon_container" v-if="item.itemValue !=null">
          <img :src="require('../../assets/cowboy/' + item.itemValue + '.png')" alt=""
               :class="{ deep: item.isWin  }"
          >
            <div class="icon_num { deep: item.isWin }" v-if="item.itemNum>1">x{{item.itemNum}}</div>
          </div>
        </div>
      </div>
      <div>{{this.drawLines()}}</div>
  </div>
</template>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/game_5016.vue